/**
 * Branded primitive aliases for Sill's spec §3 entities.
 *
 * The `Brand<T, B>` helper marks a primitive with a phantom tag so TypeScript
 * treats `MandateId` and `AgentId` as incompatible even though both are
 * `string` at runtime. Runtime constructors (mint functions) live in
 * `packages/mandate` — this package is type-only.
 *
 * See ADR-0002 for the full rationale and the closed list of IDs.
 */
/**
 * Shared `AgentId` shape — the single source of truth for the regex that
 * validates `agent_<slug>`. The slug alphabet (`[a-z0-9_]`) and the 1..64
 * char bound match the verifier's own `AGENT_ID_RE` in
 * `packages/mandate/src/verify.ts` and the publish validator's
 * `AGENT_ID_RE` in `services/api/src/sites/policy-rules-validate.ts` —
 * callers that compared agent-ids inline against local copies of this
 * regex (dashboard forms, mandate-detail inline-rule CTA, etc.) should
 * import this constant so a shape widening lands in one place.
 */
export const AGENT_ID_RE = /^agent_[a-z0-9_]{1,64}$/;
//# sourceMappingURL=brands.js.map